import { Expose, Transform } from "class-transformer";
import formatISO from "date-fns/formatISO";
import { observable } from "mobx";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class EnumBank {
  id!: number;

  @observable
  value!: string;

  @observable
  desc!: string;

  @observable
  state!: string;

  @observable
  @Transform(value => (value ? new Date(value) : undefined), { toClassOnly: true })
  @Transform(value => (value ? formatISO(value, { representation: "date" }) : undefined), { toPlainOnly: true })
  @Expose({ name: "valid_from" })
  validFrom!: Date;

  @observable
  @Transform(value => (value ? new Date(value) : undefined), { toClassOnly: true })
  @Transform(value => (value ? formatISO(value, { representation: "date" }) : undefined), { toPlainOnly: true })
  @Expose({ name: "valid_to" })
  validTo?: Date;

  /**
   * Allow to choose?
   */
  @observable
  active?: boolean;

  static ValidationRules = {
    id: { required: true, number: true },
    value: { required: true },
    desc: { required: true },
    state: { required: true },
    validFrom: { required: true, date: true },
    validTo: { date: true },
  };
}
